// ============================================================================
// UKRAINIAN TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Захоплюючі факти про Біблію

export const bibleFacts = [
  {
    category: "структура",
    text: "Біблія містить 66 книг, написаних понад 40 різними авторами протягом приблизно 1500 років",
    source: "Канонічна структура Біблії"
  },
  {
    category: "розмір",
    text: "Біблія містить 31 173 вірші, 1 189 розділів і приблизно 783 137 слів у своїй оригінальній версії",
    source: "Біблійний текстуальний аналіз"
  },
  {
    category: "переклад",
    text: "Біблія була перекладена повністю або частково на понад 3 000 мов, що робить її найперекладанішою книгою у світі",
    source: "Об'єднані біблійні товариства"
  },
  {
    category: "вірш",
    text: "Найкоротший вірш у Біблії - 'Ісус заплакав' (Івана 11:35), а найдовший - Естер 8:9",
    source: "Біблійний текстуальний аналіз"
  },
  {
    category: "популярність",
    text: "Біблія - найпродаваніша книга всіх часів, розповсюджено понад 5 мільярдів примірників",
    source: "Видавничі записи"
  },
  {
    category: "історія",
    text: "Сувої Мертвого моря, виявлені в 1947 році, містять біблійні рукописи віком понад 2 000 років",
    source: "Біблійна археологія"
  },
  {
    category: "центр",
    text: "Центральний розділ Біблії - Псалом 118, а центральний вірш - Псалом 118:8",
    source: "Числова структура Біблії"
  }
];

export default bibleFacts;
